import React from 'react';

export default function OnKeyEnterHook(key: React.KeyboardEvent<HTMLInputElement | HTMLDivElement> | undefined, func: Function) {
  if (key?.key === 'Enter') {
    func();
  }
}
